export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      rangeTest: 'Range Test Results',
      rasklading: 'Charging Prices',
      samarbeid: 'Sponsors',
      contact: 'Contact'
    },

    // Landing Page
    landing: {
      title: 'Electric Vehicle Range Testing',
      description: 'Welcome to our comprehensive electric vehicle range testing platform. We conduct real-world tests under various weather conditions and seasons to provide you with accurate, reliable data on EV performance.',
      useNavigation: 'Use the navigation above to explore our test results'
    },

    // Home/Range Test Page
    rangeTest: {
      title: 'Electric Vehicle Range Test',
      subtitle: 'Real-world range testing results under different weather conditions',
      infoTooltip: 'Our comprehensive testing methodology includes controlled highway and city driving under various weather conditions to provide accurate, real-world range data.',
      allSeasons: 'All Seasons',
      summerTests: 'Summer Tests',
      winterTests: 'Winter Tests',
      allWeather: 'All Weather',
      sun: 'Sun',
      rain: 'Rain',
      snow: 'Snow',
      cloudy: 'Cloudy',
      night: 'Night',
      sortByRange: 'Sort by Result',
      sortByTemp: 'Sort by Temp',
      sortByCharging: 'Sort by Charging',
      sortByNewest: 'Newest First',
      searchPlaceholder: 'Search by make or model...',
      showing: 'Showing',
      testResult: 'test result',
      testResults: 'test results',
      disclaimer: 'All range tests conducted under controlled conditions. Results may vary based on driving style, weather, and terrain.',
      method: 'This is how we test: start at 10 %, charge for 15 minutes, then drive at 120 km/h until the battery is back at 10 %.',
      seasonLabel: 'Season',
      weatherLabel: 'Weather',
      sortLabel: 'Sorting',
      viewCards: 'Cards',
      viewTable: 'Table',
      noResults: 'No tests match your filters.',
      resetFilters: 'Reset Filters',
      loadError: 'Could not load test results. Please try again later.',
      tableCar: 'Car',
      tableRange: 'Result',
      tableCharging: 'Charging',
      tableDate: 'Test Date',
      tableVideo: 'Video'
    },

    // Car Card
    card: {
      tires: 'Tires',
      testTemp: 'Test Temp',
      tested: 'Tested',
      kilometers: 'kilometers',
      minutesOnRoad: 'min on the road',
      battery: 'Battery',
      batteryChemistry: 'Battery Chemistry',
      maxCharging: 'Max Charging',
      drive: 'Drive',
      wltpRange: 'WLTP Range',
      power: 'Power',
      weight: 'Weight',
      summer: 'Summer',
      winter: 'Winter',
      compare: 'Compare',
      comparing: 'Comparing',
      viewComparison: 'View Comparison',
      closeComparison: 'Close Comparison',
      removeFromComparison: 'Remove',
      clearAll: 'Clear all',
      addedIn15: 'added with 15 minutes of charging',
      moreInfo: 'More info',
      comparisonTitle: 'Comparison'
    },

    // Samarbeid Page
    samarbeid: {
      title: 'Sponsors',
      subtitle: 'Our partners and collaborators',
      begoodDesc: 'Use code "Effekt" for 15% off',
      raskladingDesc: 'Find updated charging prices across Norway',
      teslaDesc: 'Tesla referral link',
      referralTitle: 'Referral Links',
    },

    // Contact Page
    contact: {
      message: 'Have questions about our tests? Want to collaborate? We\'d love to hear from you.',
      showEmail: 'Show Email Address',
      emailLabel: 'Send your message to:'
    },

    // YouTube Feed
    youtube: {
      title: 'Latest Videos',
      loading: 'Loading videos...',
      visitChannel: 'Visit YouTube Channel',
      subscribe: 'Subscribe'
    },

    // Admin Panel
    admin: {
      title: 'Admin Panel',
      subtitle: 'Add new car range test results to the database',
      backToSite: 'Back to Main Site',
      vehicleInfo: 'Vehicle Information',
      testConditions: 'Test Conditions',
      testResults: 'Test Results',
      vehicleSpecs: 'Vehicle Specifications',
      make: 'Make',
      model: 'Model',
      year: 'Year',
      weather: 'Weather',
      season: 'Season',
      temperature: 'Temperature',
      testDate: 'Test Date',
      range: 'Range',
      batterySize: 'Battery Size',
      maxChargingSpeed: 'Max Charging Speed',
      drivetrain: 'Drivetrain',
      wltpRangeLabel: 'WLTP Range',
      powerLabel: 'Power',
      weightLabel: 'Weight',
      addTestResult: 'Add Test Result',
      adding: 'Adding...',
      successMessage: 'Successfully added',
      errorServerRunning: 'Make sure the admin server is running (npm run server).'
    }
  },

  no: {
    // Navigation
    nav: {
      home: 'Hjem',
      rangeTest: 'Ladestopp-test',
      rasklading: 'Ladepriser',
      samarbeid: 'Samarbeid',
      contact: 'Kontakt'
    },

    // Landing Page
    landing: {
      title: 'EFFEKT',
      description: 'Alt du trenger å vite om elbil, ærlig og ufiltrert fra William'
    },

    // Home/Range Test Page
    rangeTest: {
      title: 'Hvor langt går bilen på 15 minutter med lading?',
      subtitle: 'Denne testen simulerer en langtur hvor man stopper for å lade. Den gir realistisk rekkevidde og tid mellom ladestopp.',
      infoTooltip: 'Vi starter på 10%, deretter lader vi 15 minutter. Så kjører vi 120 km/t til vi er tilbake på 10%. Dette er road trip-rekkevidden vår. Effektivitet og ladehastighet er viktig i denne testen.',
      allSeasons: 'Alle sesonger',
      summerTests: 'Sommertester',
      winterTests: 'Vintertester',
      allWeather: 'Alt vær',
      sun: 'Sol',
      rain: 'Regn',
      snow: 'Snø',
      cloudy: 'Overskyet',
      night: 'Natt',
      sortByRange: 'Sorter etter resultat',
      sortByTemp: 'Sorter etter temp',
      sortByCharging: 'Sorter etter ladeeffekt',
      sortByNewest: 'Nyeste først',
      searchPlaceholder: 'Søk etter merke eller modell...',
      showing: 'Viser',
      testResult: 'testresultat',
      testResults: 'testresultater',
      disclaimer: 'Alle rekkeviddetester utført under ukontrollerte forhold. Resultater vil variere.',
      method: 'Slik tester vi: Vi starter på 10 %, lader i 15 minutter, og kjører 120 km/t til vi er tilbake på 10 %.',
      seasonLabel: 'Sesong',
      weatherLabel: 'Vær',
      sortLabel: 'Sortering',
      viewCards: 'Kort',
      viewTable: 'Tabell',
      noResults: 'Ingen tester matcher filtrene dine.',
      resetFilters: 'Nullstill filtre',
      loadError: 'Kunne ikke laste testresultatene. Prøv igjen senere.',
      tableCar: 'Bil',
      tableRange: 'Resultat',
      tableCharging: 'Ladeeffekt',
      tableDate: 'Testdato',
      tableVideo: 'Video'
    },

    // Car Card
    card: {
      tires: 'Dekk',
      testTemp: 'Test Temp',
      tested: 'Testet',
      kilometers: 'kilometer',
      minutesOnRoad: 'min på veien',
      battery: 'Batteri',
      batteryChemistry: 'Batterikjemi',
      maxCharging: 'Maks oppgitt ladeeffekt',
      drive: 'Drift',
      wltpRange: 'WLTP rekkevidde',
      power: 'Kraft',
      weight: 'Vekt',
      summer: 'Sommer',
      winter: 'Vinter',
      compare: 'Sammenlign',
      comparing: 'Sammenligner',
      viewComparison: 'Vis sammenligning',
      closeComparison: 'Lukk sammenligning',
      removeFromComparison: 'Fjern',
      clearAll: 'Fjern alle',
      addedIn15: 'lagt til på 15 minutter med lading',
      moreInfo: 'Mer info',
      comparisonTitle: 'Sammenligning'
    },

    // Samarbeid Page
    samarbeid: {
      title: 'Samarbeid',
      subtitle: 'Våre samarbeidspartnere',
      begoodDesc: 'Bruk koden "Effekt" for 15% rabatt',
      raskladingDesc: 'Finn oppdaterte ladepriser i hele Norge',
      teslaDesc: 'Tesla referral-lenke',
      referralTitle: 'Henvisningslenker',
    },

    // Contact Page
    contact: {
      message: 'Vil du samarbeide? Ta kontakt med meg nedenfor.',
      showEmail: 'Vis e-postadresse',
      emailLabel: 'Send meldingen din til:'
    },

    // YouTube Feed
    youtube: {
      title: 'Siste videoer',
      loading: 'Laster videoer...',
      visitChannel: 'Besøk YouTube-kanalen',
      subscribe: 'Abonner'
    },

    // Admin Panel
    admin: {
      title: 'Adminpanel',
      subtitle: 'Legg til nye bil rekkevidde testresultater til databasen',
      backToSite: 'Tilbake til Hovedside',
      vehicleInfo: 'Kjøretøysinformasjon',
      testConditions: 'Testforhold',
      testResults: 'Testresultater',
      vehicleSpecs: 'Kjøretøyspesifikasjoner',
      make: 'Merke',
      model: 'Modell',
      year: 'År',
      weather: 'Vær',
      season: 'Sesong',
      temperature: 'Temperatur',
      testDate: 'Test Dato',
      range: 'Rekkevidde',
      batterySize: 'Batteristørrelse',
      maxChargingSpeed: 'Maks ladehastighet',
      drivetrain: 'Drivlinje',
      wltpRangeLabel: 'WLTP Rekkevidde',
      powerLabel: 'Kraft',
      weightLabel: 'Vekt',
      addTestResult: 'Legg til testresultat',
      adding: 'Legger til...',
      successMessage: 'Vellykket, lagt til',
      errorServerRunning: 'Sørg for at admin serveren kjører (npm run server).'
    }
  }
};

export const t = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];

  for (const k of keys) {
    value = value?.[k];
  }

  return value || key;
};
